// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1iFh_","alertIcon":"ConfirmModal_alertIcon__1clP5"};